<template>
  <v-container>
    <div class="button-group">
      <button
        class="default-btn blue"
        @click="editProvider(provider)">
        Edit Details
      </button>
    </div>

    <div class="header-content">
      <div v-if="provider.logo" class="logo-wrapper">
        <img :src="provider.logo" />
      </div>

      <div class="name-wrapper">
        <h3>{{ provider.contactName }}</h3>
        <h2>{{ provider.companyName }}</h2>
      </div>

      <div class="address-wrapper">
        <span>{{ provider.addressLine_1 }}</span>
        <span>{{ provider.addressLine_2 }}</span>
        <span>
          {{ provider.addressCity }},
          {{ provider.addressState }}
          {{ provider.addressZip }}
        </span>
      </div>
    </div>

    <div class="body-content">
      <h4>About {{ provider.companyName }}</h4>

      <p>
        {{ provider.description }}
      </p>

      <div class="links-wrapper">
        <a
          v-if="!!provider.linkWebsite"
          class="default-btn link small"
          target="_blank"
          :href="provider.linkWebsite">
          Website
        </a>

        <a
          v-if="!!provider.linkLinkedin"
          class="default-btn link small"
          target="_blank"
          :href="provider.linkLinkedin">
          LinkedIn
        </a>

        <a
          v-if="!!provider.email"
          class="default-btn link small"
          :href="`mailto:${provider.email}`">
          {{ provider.email }}
        </a>

        <a
          v-if="!!provider.phone"
          class="default-btn link small"
          :href="`tel:${provider.phone}`">
          {{ provider.phone }}
        </a>
      </div>
    </div>

    <CreateEditProvider
      v-if="!!createEditProvider"
      :originalProvider="createEditProvider"
      :editing="true"
      :saving="saving"
      @cancel="createEditProvider = null"
      @submit="editProvider($event, true)" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import CreateEditProvider from '../../components/CreateEditProvider'

export default {
  name: 'AdminProviderDetails',
  components: {
    CreateEditProvider,
  },
  props: {
    providerId: String,
  },

  data: () => ({
    provider: {},

    createEditProvider: null,
    saving: false,
  }),

  computed: {
    ...mapGetters('feathers', ['apiProviders']),
  },

  created () {
    this.getProviderDetails()
  },

  methods: {
    async getProviderDetails () {
      try {
        this.provider = await this.apiProviders.get(this.providerId)
      } catch (error) {
        this.addErrorAlert('The provider details could not be retrieved. Please try again and reload the page.')
      }
    },

    async editProvider (provider, confirmed = false) {
      if (!confirmed) {
        this.createEditProvider = provider
        return
      }

      try {
        this.saving = true
        this.provider = await this.apiProviders.patch(this.providerId, provider)
        this.createEditProvider = null
      } catch (error) {
        this.addErrorAlert(`Could not update provider: ${error.message}`)
      }

      this.saving = false
    },
  },
}
</script>

<style lang="scss" scoped>
h2, h3, h4 {
  color: $textDarkMuted;
  margin-bottom: 15px;
}

.header-content {
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @include lg {
    flex-direction: row;
  }

  .logo-wrapper {
    max-width: 200px;

    @include lg {
      margin-right: 35px;
    }

    img {
      height: auto;
      max-width: 100%;
    }
  }

  .name-wrapper {
    margin-top: 20px;

    h3 {
      margin-bottom: 5px;
      font-family: "Sansation Regular", sans-serif;
      font-weight: normal;
    }
  }

  .address-wrapper {
    margin-top: 20px;

    @include lg {
      margin-left: auto;
    }

    span {
      display: block;

      color: $textDarkMuted;
      font-family: "Avenir Book", sans-serif;
      font-size: 16px;
      line-height: 20px;
      text-align: left;

      @include lg {
        text-align: right;
      }
    }
  }
}

.body-content {
  margin-bottom: 60px;

  h4 {
    font-family: "Sansation Regular", sans-serif;
    font-weight: normal;
  }

  p {
    color: black;
  }

  .links-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include md {
      flex-direction: row;
      align-items: center;
    }

    a {
      display: flex;
      position: relative;
      margin: 0 5px 10px !important;
      padding: 0 10px !important;
      min-height: 0;

      &:not(:first-child):before {
        content: '';
        position: absolute;
        background-color: #D5D5D5;

        @include smAndBelow {
          top: -8px;
          left: 10px;
          height: 2px;
          width: 30px;
        }

        @include md {
          top: 0;
          bottom: 0;
          left: -4px;
          width: 2px;
        }
      }
    }
  }
}

.button-group {
  justify-content: flex-end;
  margin: -70px 0 70px;
}
</style>
